import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthViewModel } from '../../features/auth/viewmodels/auth.viewmodel';

export const authGuard: CanActivateFn = (route, state) => {
  const authViewModel = inject(AuthViewModel);
  const router = inject(Router);

  const checkAuth = () => {
    if (authViewModel.isAuthenticated()) return true;
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  };

  // Se o ViewModel já foi inicializado, verifica autenticação imediatamente.
  if (authViewModel.isInitialized()) {
    return checkAuth();
  }

  // Não mantem a navegação pendente aguardando o MSAL. Isso deixaria a
  // aplicação presa no loader quando a primeira inicialização demora.
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url }
  });
};
